import { motion } from "framer-motion";
import { ArrowUpRight, CalendarCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { enterUp } from "@/lib/motion";
import { COACHING_LINKS, PRESS } from "@/data/coaching";

export const CoachingHero = () => (
  <section data-testid="coaching-hero-section" className="pt-20">
    <div className="mx-auto max-w-6xl px-5 py-14 sm:px-8 sm:py-20">
      <div className="max-w-3xl">
        <motion.p {...enterUp(0)} className="mb-4 font-heading text-lg font-bold uppercase tracking-[0.12em] text-navy sm:text-xl lg:text-2xl">Leadership Coaching for Women</motion.p>
        <motion.h1 {...enterUp(0.1)} data-testid="coaching-headline" className="font-heading text-2xl font-bold leading-[1.1] tracking-tight text-ink sm:text-3xl">
          Find your voice. Lead with confidence. Make room for you<span className="text-navy">.</span>
        </motion.h1>
        <motion.p {...enterUp(0.2)} className="mt-6 text-base leading-relaxed text-ink/70 sm:text-lg">
          I coach women in leadership to own their voice, balance family and work, and make time for themselves, with strategy that actually works.
        </motion.p>
        <motion.p {...enterUp(0.26)} className="mt-3 font-heading text-lg font-semibold text-navy">Let's get clear on your next move, together.</motion.p>
        <motion.div {...enterUp(0.34)} className="mt-10 flex flex-col gap-3 sm:flex-row">
          <Button asChild data-testid="coaching-hero-cta" className="btn-primary h-13 px-7 text-base">
            <a href={COACHING_LINKS.calendly} target="_blank" rel="noopener noreferrer"><CalendarCheck className="mr-2 h-5 w-5" /> Work with Kelly</a>
          </Button>
          <Button asChild variant="ghost" data-testid="coaching-hero-programs-link" className="btn-ghost h-13 px-6 text-base">
            <a href="#work-with-kelly">See how we can work together <ArrowUpRight className="ml-1.5 h-4 w-4" /></a>
          </Button>
        </motion.div>
      </div>
    </div>
  </section>
);

export const FeaturedIn = () => (
  <section data-testid="featured-in-section">
    <div className="bg-white py-14">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <h2 className="font-heading text-3xl font-bold tracking-tight sm:text-4xl text-ink">As Featured In</h2>
      </div>
      <div data-testid="coaching-press-strip" className="ticker mt-10 flex w-full overflow-hidden">
        <div className="ticker-track flex shrink-0 items-center">
          {[...PRESS, ...PRESS].map((p, i) => (
            <div key={`${p.name}-${i}`} className="mx-7 flex h-24 w-48 shrink-0 items-center justify-center">
              <img src={p.logo} alt={p.name} title={p.name} className="max-h-20 w-auto max-w-full object-contain" style={p.scale ? { transform: `scale(${p.scale})` } : undefined} />
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
